import React from "react";
import { Grid } from "react-flexbox-grid";

import * as styles from "./styles.module.css";

const IntroText = ({ children, title }) => (
  <Grid>
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div>{children}</div>
    </div>
  </Grid>
);

export default IntroText;
